export default {"src":"/_next/static/media/linkedin-icon.89b91197.svg","height":24,"width":24};